var $tables = $('.table-simple');
var lang = $('#root').attr('lang');
var note = ''; // console.log(lang);

if (lang === 'ja') {
  note = '※画面より大きなテーブルは横スクロールができます';
} else if (lang === 'en') {
  note = '* This table is scrollable horizontally.';
}

$tables.each(function (index, elem) {
  var $this = $(elem);
  var $caption = $('<p></p>', {
    class: 'mbnote',
    text: note
  });
  $this.prepend($caption);
});